import { PropTypes } from 'prop-types';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { Button } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { useState } from 'react';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';

DetailKnowledgeGroupActionButton.propTypes = {
    hasEditFieldPermissions: PropTypes.bool,
    hasEditSettingPermissions: PropTypes.bool,
    detailTicket: PropTypes.any,
    userDetail: PropTypes.any,
    setIsOpenDialogConfirmBackToDraft: PropTypes.any,
    isDisableBtnSaveTicket: PropTypes.any,
    submitEditTicket: PropTypes.any,
    setIsShowDialogRestoreTicket: PropTypes.any,
    displayMode: PropTypes.any,
    setDisplayMode: PropTypes.any,
    isEdited: PropTypes.bool,
    cancelEditTicket: PropTypes.any
};

export default function DetailKnowledgeGroupActionButton(props) {
    const {
        hasEditFieldPermissions,
        hasEditSettingPermissions,
        detailTicket,
        userDetail,
        setIsOpenDialogConfirmBackToDraft,
        isDisableBtnSaveTicket,
        submitEditTicket,
        setIsShowDialogRestoreTicket,
        displayMode,
        setDisplayMode,
        isEdited,
        cancelEditTicket
    } = props;

    const [displayPopupConfirmCancel, setDisplayPopupConfirmCancel] = useState(false);

    const isDisplayButtonCancelEdit = () => {
        return (
            Utils.isEmptyString(detailTicket?.deletedAt) &&
            displayMode === Constant.DISPLAY_MODE.EDIT
        );
    };

    const isDisplayButtonBackToDraft = () => {
        return (
            displayMode === Constant.DISPLAY_MODE.EDIT &&
            userDetail.id === detailTicket.creator &&
            Utils.isEmptyString(detailTicket?.deletedAt)
        );
    };

    const isDisplayButtonSaveEdit = () => {
        return (
            displayMode === Constant.DISPLAY_MODE.EDIT &&
            Utils.isEmptyString(detailTicket?.deletedAt)
        );
    };

    const handleClickBtnCancelEdit = () => {
        if (!isEdited) {
            return setDisplayMode(Constant.DISPLAY_MODE.VIEW);
        }

        setDisplayPopupConfirmCancel(true);
    };

    const handleConfirmCancelEdit = () => {
        setDisplayPopupConfirmCancel(false);
        cancelEditTicket();
        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
    };

    const isDisplayButtonRestore = () => {
        return !Utils.isEmptyString(detailTicket?.deletedAt);
    };

    const isDisplayAnyButton =
        isDisplayButtonCancelEdit() ||
        isDisplayButtonBackToDraft() ||
        isDisplayButtonSaveEdit() ||
        isDisplayButtonRestore();

    if (!isDisplayAnyButton) return <></>;

    return (
        (hasEditFieldPermissions || hasEditSettingPermissions) && (
            <div className="btnHead">
                <div className="btnHead-btn">
                    {/* Cancel */}
                    {isDisplayButtonCancelEdit() && (
                        <Button
                            className="btn-send btn-outline-primary btn-hg32"
                            variant="contained"
                            onClick={() => handleClickBtnCancelEdit()}
                        >
                            {I18n.get('BUTTON-CANCEL-EDIT')}
                        </Button>
                    )}

                    {/* Back to draft */}
                    {isDisplayButtonBackToDraft() && (
                        <Button
                            className="btn-send btn-outline-primary btn-hg32 back-to-draft"
                            variant="contained"
                            color="primary"
                            onClick={() => setIsOpenDialogConfirmBackToDraft(true)}
                        >
                            {I18n.get('BACK_TO_DRAFT')}
                        </Button>
                    )}

                    {/* Save */}
                    {isDisplayButtonSaveEdit() && (
                        <Button
                            className="btn-send btn-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            onClick={e => submitEditTicket()}
                            disabled={isDisableBtnSaveTicket()}
                        >
                            {I18n.get('COMBTN011')}
                        </Button>
                    )}
                </div>

                {/* Restore */}
                {isDisplayButtonRestore() && (
                    <div className="btnHead-btn">
                        <Button
                            className="btn-send btn-outline-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            onClick={() => setIsShowDialogRestoreTicket(true)}
                        >
                            {I18n.get('RESTORE')}
                        </Button>
                    </div>
                )}

                {/* Popup confirm cancel */}
                <ConfirmDialog
                    isOpen={displayPopupConfirmCancel}
                    msgConfirm={I18n.get('MSG-CM-CONFIRM-CANCEL-DATA-CHANGE')}
                    textSubmit={I18n.get('CM-BUTTON-OK')}
                    okCallBack={e => handleConfirmCancelEdit()}
                    textClose={I18n.get('CM-BUTTON-CANCEL')}
                    closeCallBack={() => setDisplayPopupConfirmCancel(false)}
                />
            </div>
        )
    );
}
